<template>
  <table :class="[baseClass, variantClasses]">
    <thead v-if="showTHead">
      <tr>
        <th v-for="(head, headIndex) in heads.cols" :key="headIndex">
          {{ head }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, itemID) in items" :key="itemID">
        <td v-for="(column, columnId) in item" :key="columnId">{{ column }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
const ns = 'b2b-';
const name = 'table';
export default {
  props: {
    variants: {
      type: [String, Array],
      default: '',
    },
    showTHead: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      baseClass: `${ns}${name}`,
      heads: {
        cols: ['Thats how', 'Easy Vue', 'Can Be'],
      },
      items: {
        1: ['A', 'B', 'C'],
        2: ['1', '2', '3'],
        3: ['Doe', 'Rae', 'Me'],
      },
    };
  },
  computed: {
    variantClasses() {
      return this.variants
        .split(' ')
        .map((variant) => `${ns}${name}--${variant}`)
        .join(' ');
    },
  },
};
</script>
<style></style>
